import { EventCard } from '@/sanity/fetchEvents';
import HIHLink from './Link';
import HIHImage from './Image';
import { CategoryTag } from './Tag';
import { CategoryLink } from '@/sanity/fetchCategories';
import EventFacts from '../sections/EventFacts';
import { URL_PATH_EVENT } from '@/shared/constants';
import { cn } from '@/utils/cn';

interface SingleEventCardProps {
  event: EventCard;
  variant?: 'primary' | 'secondary';
}

export const SingleEventCard = ({ event, variant = 'primary' }: SingleEventCardProps) => {
  const imageStyle =
    variant === 'primary' ? 'rounded-tr-2xl rounded-tl-2xl' : 'rounded-2xl';
  const bottomHalfStyle =
    variant === 'primary'
      ? 'p-xl md:p-3xl bg-sys/surface/surface-container-lowest rounded-bl-2xl rounded-br-2xl shadow-1'
      : 'py-2xl';

  return (
    <div className="group">
      <div className={`${imageStyle} overflow-hidden `}>
        <HIHLink href={`/${URL_PATH_EVENT}/${event.slug.current}`}>
          <HIHImage
            className={`w-full aspect-4/3 object-cover group-hover:scale-105 transition scale-100 duration-500 overflow-hidden`}
            image={event.coverImage}
            width={500}
            height={500}
          />
        </HIHLink>
      </div>
      <div className={`flex flex-col ${bottomHalfStyle}`}>
        <div>
          <div className=" flex flex-wrap max-h-[32px] overflow-hidden gap-md mb-2xl">
            {event.categories?.map((category: CategoryLink) => (
              <CategoryTag key={category._id} category={category} />
            ))}
          </div>
          <HIHLink href={`/${URL_PATH_EVENT}/${event.slug.current}`}>
            <div className="font-display text-headline-lg mb-2xl">{event.title}</div>
          </HIHLink>
        </div>
        <EventFacts event={event} />
      </div>
    </div>
  );
};
